/**
 * classNames.ts
 * ----------------
 * Utility that helps calculate class names for JSX components.
 */

class ClassNamesBuilder<T> {
    private readonly props: T;
    private classNames: string[];

    constructor (props: T) {
        this.classNames = [];
        this.props = props;
    }

    add (className: string, predicate?: (p: T) => boolean) {
        if (predicate === undefined || predicate(this.props)) {
            this.classNames = [...this.classNames, className];
        }

        return this;
    }

    value () {
        return this.classNames.join(' ');
    }
}

export function classNames<T> (props: T) {
    return new ClassNamesBuilder(props);
}
